import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setChildPopup, setPopup } from 'modules/popup/actions';
import app from 'new-ui/app';
import { GA_GENERAL_CATEGORY, GA_GENERAL_EVENTS, GA_GENERAL_POPUPS_SOURCES } from 'modules/ga/generalEvents';
import { PopupVersion } from './PopupVersion';

const sendPopupOpenGAEvent = (type) => (
  app.sendGoogleAnalyticsEvent(
    GA_GENERAL_CATEGORY,
    GA_GENERAL_EVENTS.POPUP_OPEN,
    { popup: type, source: GA_GENERAL_POPUPS_SOURCES.DASHBOARD },
  )
);

export const Popups = () => {
  const dispatch = useDispatch();
  const { popup, childPopup } = useSelector((state) => state.popup);

  const { type: popupType } = popup || {};
  const { type: childPopupType } = childPopup || {};

  useEffect(() => {
    if (popupType) {
      sendPopupOpenGAEvent(popupType);
    }
  }, [popupType]);

  useEffect(() => {
    if (childPopupType) {
      sendPopupOpenGAEvent(childPopupType);
    }
  }, [childPopupType]);

  const closeMainPopup = useCallback(() => {
    dispatch(setPopup(false));
  }, [dispatch]);

  const closeChildPopup = useCallback(() => {
    dispatch(setChildPopup(false));
  }, [dispatch]);

  const popups = [
    {
      popupEntry: popup,
      closePopup: closeMainPopup,
    },
    {
      popupEntry: childPopup,
      closePopup: closeChildPopup,
    },
  ];

  return (
    <div className="popups">
      {popups.map(({ popupEntry, closePopup }, index) => (
        <PopupVersion
          key={index}
          isMain={index === 0}
          isTop={index + 1 === popups.filter(({ popupEntry: { type } }) => type).length}
          zIndex={index + 1}
          closePopup={closePopup}
          popupEntry={popupEntry || null}
        />
      ))}
    </div>
  );
};
